/* eslint-disable */
import { map, uniqBy } from 'lodash';

export const roUserbased_elemodel = (elementModel, users_dict) => {

  const curr_user_email = sessionStorage.getItem('user_email');
  // const curr_user_email = 'sheril.mathew@veolia.com';

  const allUserEmails = Object.keys(users_dict);
  let user_passcode = [];

  if (allUserEmails.includes(curr_user_email)) {

   user_passcode = users_dict[curr_user_email] ?
      (users_dict[curr_user_email].F_M.split(',').map(item => Number(item)) || [0])
      :
      [0];

    if (!user_passcode.includes(0)) {
      user_passcode.unshift(0);   // add 0 in user_passcode array
    }
  }
  else {
    user_passcode = [0];
  }

  const uniqElementModels = uniqBy(elementModel, 'strModel');
  const uniqElementModel = uniqElementModels.filter((item) => {
    for (let i = 0; i < user_passcode.length; i += 1) {
      if (item.passWordCode.includes(`${user_passcode[i]}`))
        return item;
    }

  });
  return [' ', ...map(uniqElementModel, 'strModel')];
};

// RO-Machine Model Mapping to Ro Form
let allRoMachineModel = '';

export const setAllRoMachineModel = (data) => {
  allRoMachineModel = data;
}

export const getAllRoMachineModel = () => {
  return allRoMachineModel;
}